// extracted by mini-css-extract-plugin
module.exports = {"bottomMargin":"bottomMargin_t3kpW","fillRow":"fillRow_X52lv","inlineTitle":"inlineTitle_-+SlU","extra":"extra_FfDaW","titleIcon":"titleIcon_ebBvg"};